import "core-js/modules/web.dom.iterable";
export default {
  install: function install(Vue) {
    // theads所有动态表头数据
    // currHeaeItem当前表头数据
    // currRow,当前行数据
    Vue.prototype.tableCenterntFilter = function (theads, currHeaeItem, currRow) {
      // if (currHeaeItem.fieldType === "1") {
      //   return currRow[currHeaeItem.fieldCode]
      // }
      // if (currHeaeItem.fieldType === "2") {
      //   const keys = []
      //   theads &&
      //     theads.length > 0 &&
      //     theads.forEach(item => {
      //       if (item.bindField === currHeaeItem.fieldCode) {
      //         keys.push(item)
      //       }
      //     })
      //   return keys
      //     .map(item => {
      //       return `<p>${item.fieldName}：${currRow[item.fieldCode]}</p>`
      //     })
      //     .join(" ")
      // }
      var typeData = null;
      if (currHeaeItem.fieldType === "1") {
        typeData = currRow[currHeaeItem.fieldCode];
      }
      if (currHeaeItem.fieldType === "2") {
        var keys = [];
        theads && theads.length > 0 && theads.forEach(function (item) {
          if (item.bindField === currHeaeItem.fieldCode) {
            item.text = currRow[item.fieldCode];
            keys.push(item);
          }
        });
        typeData = keys;
      }
      if (currHeaeItem.fieldType === "3") {
        var _keys = [];
        theads && theads.length > 0 && theads.forEach(function (item) {
          if (item.bindField === currHeaeItem.fieldCode) {
            _keys.push(item);
          }
        });
        typeData = _keys.map(function (item) {
          // item.text = currRow[item.fieldCode]
          return item;
        });
      }
      if (currHeaeItem.fieldType === "4") {
        typeData = currRow[currHeaeItem.fieldCode];
      }
      return typeData;
    };
    Vue.prototype.filterTableHeadkey = function (tableHeadData) {
      var data = [];
      var doWithouts = ["2"];
      if (tableHeadData) {
        tableHeadData.forEach(function (item) {
          if (!doWithouts.some(function (p) {
            return p === item.fieldType;
          })) {
            data.push({
              fieldCode: item.fieldCode,
              sqlCode: item.orderByCode
            });
          }
        });
      }
      return data;
    };
    /**
     * 16进制颜色转换rgb
     */
    Vue.prototype.colorConversionRgb = function (color) {
      // 16进制颜色值的正则
      var reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;

      // 把颜色值变成小写
      var _color = color.toLowerCase();
      if (reg.test(_color)) {
        // 如果只有三位的值，需变成六位，如：#fff => #ffffff
        if (_color.length === 4) {
          var colorNew = "#";
          for (var i = 1; i < 4; i += 1) {
            colorNew += _color.slice(i, i + 1).concat(_color.slice(i, i + 1));
          }
          _color = colorNew;
        }
        // 处理六位的颜色值，转为RGB
        var colorChange = [];
        for (var _i = 1; _i < 7; _i += 2) {
          colorChange.push(parseInt("0x" + _color.slice(_i, _i + 2)));
        }
        return colorChange.join(",");
      } else {
        return _color;
      }
    };
  }
};